import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6d3e572b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "main"
}
const _hoisted_2 = {
  key: 0,
  class: "card-title"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "square-left" }, null, -1))
const _hoisted_4 = { class: "card-title-text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "square-right" }, null, -1))
const _hoisted_6 = {
  key: 1,
  class: "card-desc"
}
const _hoisted_7 = {
  key: 2,
  class: "card-desc-leval"
}
const _hoisted_8 = {
  key: 3,
  class: "btn-group"
}
const _hoisted_9 = {
  key: 4,
  class: "btn-single"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["detail-lottie", { 'small-detail-lottie': $setup.isSmallPhone }]),
          id: "detail-lottie-main"
        }, null, 2),
        ($props.cardInfo.cardName && $props.type === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, _toDisplayString($props.cardInfo.cardName), 1),
              _hoisted_5
            ]))
          : _createCommentVNode("", true),
        ($props.type === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("p", null, _toDisplayString($props.cardInfo.cardDesc), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("p", null, _toDisplayString($props.cardInfo.rewardContent), 1)
            ])),
        ($props.type !== 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", {
                class: "btn see",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.see && $setup.see(...args)))
              }, "去看看"),
              _createElementVNode("div", {
                class: "btn share",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.share && $setup.share(...args)))
              }, "去分享"),
              _withDirectives(_createElementVNode("div", {
                class: "btn customize-btn",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.handleJump && $setup.handleJump(...args)))
              }, _toDisplayString($props.cardInfo.btnJumpText), 513), [
                [_vShow, $setup.showThirdBtn]
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", {
                class: "btn see",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.share && $setup.share(...args)))
              }, "去分享")
            ])),
        _createElementVNode("div", {
          class: "close-mask",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.close && $setup.close(...args)))
        })
      ]))
    : _createCommentVNode("", true)
}